import React, { useEffect, useState } from "react";

import { getLoggedInUser } from "../helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  const [isDashboard, setIsDashboard] = useState(false);
  const [isnewUser, setIsnewUser] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isItem, setIsItem] = useState(false);
  const [isListItem, setIsListItem] = useState(false);
  const [isProcurement, setIsProcurement] = useState(false);

  const [isPeople, setIsPeople] = useState(false);
  const [isPaymentReport, setIsPaymentReport] = useState(false);
  const [isSetup, setIsSetup] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isSales, setIsSales] = useState(false);
  const [isLogs, setIsLogs] = useState(false);

  const [isPaymentType, setIsPaymentType] = useState(false);
  const [isMenuCategory, setIsMenuCategory] = useState(false);
  const [isMenuItem, setMenuItem] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isWaiter, setIsWaiter] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  // const userRole = authUser?.user?.roles[0]?.toLowerCase();
  // console.log("🚀 ~ Navdata ~ userRole:", userRole);
  // const isSuperAdmin = authUser.user.roles.includes("SuperAdmin");
  // const isSuperAdmin = true;
  // console.log("isSuperAdmin", isSuperAdmin);
  // const isAdmin = true;

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "people-management") {
      setIsPeople(false);
    }

    if (iscurrentState !== "PaymentReport") {
      setIsPaymentReport(false);
    }

    if (iscurrentState !== "payment-type") {
      setIsPaymentType(false);
    }
    if (iscurrentState !== "menu-category") {
      setIsMenuCategory(false);
    }
    if (iscurrentState !== "menu-item") {
      setMenuItem(false);
    }

    if (iscurrentState !== "setting") {
      setIsSetting(false);
    }

    if (iscurrentState !== "settings") {
      setIsWaiter(false);
    }
    if (iscurrentState !== "Table") {
      setIsTable(false);
    }
    if (iscurrentState !== "sales-report") {
      setIsSales(false);
    }
    if (iscurrentState !== "logs") {
      setIsLogs(false);
    }
    if (iscurrentState !== "user-management") {
      setIsUser(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isSetup,

    isPeople,

    isPaymentReport,

    isPaymentType,
    isMenuCategory,
    isMenuItem,
    isUser,
    isSetting,
    isWaiter,
    isTable,
    isSales,
    isLogs,
  ]);

  const cashierMenuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "dispute-claim",
      label: "Dispute Claim",
      icon: "ri-database-2-line", // or any other icon you like
      link: "/dispute-claim", // route to navigate to
      click: (e) => {
        e.preventDefault();
        // Optional: if you want to track active state
        setIscurrentState("dispute-claim");
        updateIconSidebar(e);
      },
    },

    // {
    //   id: "restro-query-logs",
    //   label: "Restro Users Query",
    //   icon: "ri-group-line", // or any other icon you like
    //   link: "/restrousersquerylogs", // route to navigate to
    //   click: (e) => {
    //     e.preventDefault();
    //     // Optional: if you want to track active state
    //     setIscurrentState("restro-query-logs");
    //     updateIconSidebar(e);
    //   },
    // },

    // {
    //   id: "restro-user-logs",
    //   label: "Restro Users Logs",
    //   icon: "ri-database-2-line", // or any other icon you like
    //   link: "/restrouserslogs", // route to navigate to
    //   click: (e) => {
    //     e.preventDefault();
    //     // Optional: if you want to track active state
    //     setIscurrentState("restro-user-logs");
    //     updateIconSidebar(e);
    //   },
    // },

    // {
    //   id: "restro-user-info",
    //   label: "Restro Users Info",
    //   icon: "ri-database-2-line", // or any other icon you like
    //   link: "/restrousers", // route to navigate to
    //   click: (e) => {
    //     e.preventDefault();
    //     // Optional: if you want to track active state
    //     setIscurrentState("restro-user-logs");
    //     updateIconSidebar(e);
    //   },
    // },
  ];
  let filteredMenuItems;

 

  return <React.Fragment>{cashierMenuItems}</React.Fragment>;
};

export default Navdata;
